<template>
  <div>
    <v-autocomplete
      v-if="l_visible"
      :data-id="dataId"
      :dense="dense"
      :outlined="outlined"
      :multiple="multiple"
      :placeholder="placeholder"
      :menu-props="menuProps"
      :items="data"
      :value="currentValue"
      :item-text="l_displayMember"
      :item-value="l_valueMember"
      :loading="isLoading"
      :rules="getRules"
      :filter="customFilter"
      @focusout="lostFocus"
      @change="onChange"
      @mousedown="handleMouseDown"
      :return-object="returnObject"
      :append-icon="getDisabled ? '' : 'mdi-chevron-down'"
      ref="control"
      :class="{
        validated: displayValidated && !hasError && !errorMessages,
        required: l_required,
        naked,
        readonly: readonly || isDisabled || isLoading,
      }"
      :error-messages="errorMessages"
      :clearable="clearable"
      :disabled="getDisabled"
      :readonly="readonly"
      class="dynamic-input-control"
    >
      <template v-slot:label>
        {{ getLabel }}
        <span v-if="optional" class="optional">(nepovinné)</span>
      </template>
      <template v-slot:append>
        <div class="v-input__icon v-input__icon--append" v-if="!getDisabled">
          <v-icon>mdi-chevron-down</v-icon>
        </div>
        <v-tooltip v-if="!!getTooltip && !hideTooltip" bottom max-width="350">
          <template v-slot:activator="{ on }">
            <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
              >mdi-help-circle</v-icon
            >
          </template>
          <span> {{ getTooltip }} </span>
        </v-tooltip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  mixins: [dynamicControlMixin],
  props: {
    value: [Array, Number, String, Object],
    refreshDataOn: [Array, String], //id comboxov, na ktorych refresh event combo pocuva
    refreshDataCondition: String, //nazov premennej, ktore posiela (spolu s hodnotou) combobox navesenemu combu
    valueMember: {
      type: String,
      default: 'valueMember',
    },
    displayMember: {
      type: String,
      default: 'displayMember',
    },
    dense: Boolean,
    outlined: {
      type: Boolean,
      default: true,
    },
    multiple: Boolean,
    menuProps: Object,
    placeholder: String,
    optional: Boolean,
    source: String,
    items: {
      type: Array,
      default: null,
    },
    clearable: Boolean,
    naked: Boolean,
    returnObject: Boolean,
    fulltextFilter: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: null,
      currentValue: this.value,
      //kopie props aby nedochadzalo k mutating props
      l_displayMember: this.displayMember,
      l_valueMember: this.valueMember,
    };
  },

  watch: {
    value(val) {
      if (val === this.currentValue) return;
      this.update(val);
    },
    items(val){
      if(!this.cache)
        this.data = val;
    }
  },
  computed:{
    getDisabled(){
      return this.disabled || this.isDisabled || this.isLoading
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const qt = queryText.toLowerCase();
      const it = itemText.toLowerCase();
      if (this.fulltextFilter) return it.includes(qt);
      else return it.startsWith(qt);
    },
    onChange(val) {
      this.setDirty(true);
      this.update(val);
    },
    lostFocus() {
      this.$emit('input', this.currentValue);
    },
    readData(config, data) {
      if (this.dataId) {
        this.data = data;

        if (config.controlValue || config.controlValue === 0) this.update(config.controlValue);
        else if (this.currentValue) this.currentValue = null;
      } else {
        this.data = null; //res.data;
      }

      if (this.data?.length > 0) {
        //upravim displaymember a valuemember
        if (Object.prototype.hasOwnProperty.call(this.data[0], 'DisplayMember')) {
          this.l_displayMember = 'DisplayMember';
        }

        if (Object.prototype.hasOwnProperty.call(this.data[0], 'ValueMember')) {
          this.l_valueMember = 'ValueMember';
        }

        //kontrola ci sedi nazov pre valuemember a displaymember
        if (!Object.prototype.hasOwnProperty.call(this.data[0], this.l_displayMember))
          console.warn(
            `Combobox id: '${this.dataId}' ma nespravne definovany displayMember!`,
            this.data[0]
          );

        if (!Object.prototype.hasOwnProperty.call(this.data[0], this.l_valueMember))
          console.warn(
            `Combobox id: '${this.dataId}' ma nespravne definovany valueMember!`,
            this.data[0]
          );
      }
    },
    update(newVal) {
      if (newVal === this.currentValue) return;
      let primitiveValue;
      let emitValue = newVal;
      if (this.returnObject) {
        if (newVal !== Object(newVal)) {
          emitValue = this.data.find(d => d.valueMember === newVal);
          primitiveValue = emitValue?.valueMember;
        } else {
          primitiveValue = newVal.valueMember;
        }
      } else {
        primitiveValue = newVal;
      }
      this.currentValue = emitValue;

      this.$emit('input', emitValue);
      let ignoreNull = true;
      if(this.l_dataId == 'liw_filip__wiz_predmet__cb_typy_motora'){
        ignoreNull = false;
      }
      return this.saveValue(primitiveValue, !ignoreNull);
    },
    setValue(val) {
      this.currentValue = val;
      this.$emit('input', val);
      return this.saveValue(val, true);
    },
    refresh() {
      this.update(null, false).then(() => {
        this.loadData();
      });
    },
  },
  beforeMount() {},
  mounted() {
    if (this.items) this.data = this.items;
  },
  created() {
    this.data = [];

    if (!this.dataId && this.data.length === 0) {
      console.warn('Combobox nema zadane dataId ani data source!');
      return;
    }

    if (!this.multiple && Array.isArray(this.value)) {
      console.error(
        `Combobox nie je multiple a inicialna hodnota je pole! Inicialna hodnota v tomto pripade musi byt cislo alebo string.`
      );
      this.valid = false;
      return;
    }
  },
};
</script>
